import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { recordActions, getRecordsMap } from "data/recordApi"
import WithObject from "./WithObject"

class WithRecords extends React.Component {
    render() {
        var recordsData = this.props.records
        if (this.props.ignoreLoading && !recordsData) {
            recordsData = {}
        }
        if (!recordsData) return this.props.loading ? this.props.loading : ""
        const records = recordsData[this.props.objectId]
        return (
            <WithObject objectId={this.props.objectId}>
                {({ object, primaryField }) =>
                    this.props.children({
                        records,
                        object,
                        primaryField,
                        onChange: this.props.recordActions.update,
                    })
                }
            </WithObject>
        )
    }

    constructor(props) {
        super(props)
        props.recordActions.fetchByObject(this.props.objectId)
    }
}

WithRecords.propTypes = {
    objectId: PropTypes.string,
}

function mapStateToProps(state) {
    return {
        records: getRecordsMap(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        recordActions: bindActionCreators(recordActions, dispatch),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WithRecords)



// WEBPACK FOOTER //
// ./src/data/wrappers/WithRecords.js